export default __webpack_public_path__ + "static/media/unselected3.747cc67a.png";